import { render, staticRenderFns } from "./modalCambiarClasificacion.vue?vue&type=template&id=51643092"
import script from "./modalCambiarClasificacion.vue?vue&type=script&lang=js"
export * from "./modalCambiarClasificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports